module.exports = __webpack_public_path__ + "static/img/06.5e908c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/health/06.png
// module id = Ib5e
// module chunks = 1